import { getProjectType, ProjectTypes } from '@r-and-a-shared-ui/utils';
import stylesMMB from './scss/LoadingSpinnerMMB.module.scss';
import stylesPP from './scss/LoadingSpinnerPP.module.scss';

export function LoadingSpinner() {
  const isPlayerPortals = getProjectType() === ProjectTypes.PlayerPortals;
  const styles = isPlayerPortals ? stylesPP : stylesMMB;
  return (
    <div className={styles['spinner-container']}>
      <div className={styles['loading-spinner']}></div>
    </div>
  );
}

export default LoadingSpinner;
